<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="item" :class="{active:templateId===item.id}" v-for="(item,index) in list" :key="index" @click="setStore(item)">
                    <img :src="item.image" alt="">
                    <div class="icon">
                        <div class="border">
                            <i class="iconfont icon-dagou"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="templateId" @click="$router.push($route.meta.next)">
                    下一步
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "investigate",
        data() {
            return {
                list: [],
                dialogVisible:false
            }
        },
        computed:{
            templateId(){
                return this.$store.state.record.template.id
            }
        },
        created() {
            if(!this.$store.state.record.experiment){
                this.axios.post('/student/experiment/create').then(res=>{
                    if(res.succeed && res.login){
                        this.$store.commit('setState',{key: 'record.experiment', value: res.experiment})
                    }
                })
            }
            this.getList()
        },
        methods: {
            getList() {
                this.axios.post('/student/product/template/list').then(res => {
                    if (res.succeed && res.login) {
                        this.list = res.items;
                    }
                })
            },
            setStore(item){
                this.$store.commit('setState',{key: 'record.template', value: item})
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            justify-content: center;
            padding-top: 40px;
            padding-bottom: 40px;
            min-height: calc(100% - 88px);

            .item {
                margin-right: 120px;
                cursor: pointer;
                transition: all 0.3s ease-in-out;

                &.active {
                    > .icon {
                        border-color: #FBB521;
                        > .border {
                            background: #FBB521;

                            > i {
                                color: #FFFFFF;
                            }
                        }
                    }
                }

                &:hover {
                    transform: scale(1.02);
                    transition: all 0.3s ease-in-out;
                }

                &:last-child {
                    margin-right: 0;
                }

                > img {
                    height: 400px;
                }

                > .icon {
                    margin-top: 20px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #9e9e9e;
                    position: relative;
                    left: 60%;

                    .border {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        background: #9e9e9e;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 16px;

                        > i {
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }

        .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
